exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".orders-component .kinds{position:fixed;background:#fff;width:100%;top:44px;z-index:1000;padding:10px 0;border-bottom:1px solid #f5f5f5}@media only screen and (min-width:600px){.orders-component .kinds{width:598px}}.orders-component .kinds .fives{width:20%;float:left;text-align:center}.orders-component .kinds .kind{width:60px;height:30px;display:block;line-height:30px;text-align:center;font-size:12px;margin:auto;border:1px solid rgba(0,0,0,.65);color:rgba(0,0,0,.65)}.orders-component .kinds .active{color:#f08080;border:1px solid #f08080}.orders-component .content{padding:105px 10px 0;min-height:100vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Orders.scss
// module id = 661
// module chunks = 0